import {createAction} from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  PROFILE,
  AUTH, GET, MENU, ENTRANT_VERIFICATION_CODE, RESET, ENTRANT_REGISTER,
  NOTIFICATION, SET
} from "../../constants";
import {IMenuItems} from "../../../types";

export const getMenuAction = createAction<undefined>(GET + MENU + FETCH);
export const getMenuActionDone = createAction<IMenuItems[]>(GET + MENU + FETCH + DONE);
export const getMenuActionFail = createAction<undefined>(GET + MENU + FETCH + FAIL);

export const fetchAuth = createAction<any>(AUTH + FETCH)
export const fetchAuthDone = createAction<any>(AUTH + FETCH + DONE)
export const fetchAuthFail = createAction<undefined>(AUTH + FETCH + FAIL)

export const fetchUserProfileAction = createAction<undefined>(PROFILE + FETCH);
export const fetchUserProfileActionDone = createAction<any>(PROFILE + FETCH + DONE);
export const fetchUserProfileActionFail = createAction<undefined>(PROFILE + FETCH + FAIL);

export const fetchGetNotificationAction = createAction<undefined>(GET + NOTIFICATION + FETCH);
export const fetchGetNotificationActionDone = createAction<any>(GET + NOTIFICATION + FETCH + DONE);
export const fetchGetNotificationActionFail = createAction<undefined>(GET + NOTIFICATION + FETCH + FAIL);

export const fetchSetNotificationAction = createAction<undefined>(SET + NOTIFICATION + FETCH);
export const fetchSetNotificationActionDone = createAction<any>(SET + NOTIFICATION + FETCH + DONE);
export const fetchSetNotificationActionFail = createAction<undefined>(SET + NOTIFICATION + FETCH + FAIL);



//entrant
export const fetchVerificationCodeAction = createAction(ENTRANT_VERIFICATION_CODE + FETCH);
export const fetchVerificationCodeActionDone = createAction(ENTRANT_VERIFICATION_CODE + FETCH+ DONE);
export const fetchVerificationCodeActionFail = createAction(ENTRANT_VERIFICATION_CODE + FETCH + FAIL);
export const fetchVerificationCodeActionReset = createAction(ENTRANT_VERIFICATION_CODE + RESET);


export const fetchRegisterDataAction = createAction(ENTRANT_REGISTER + FETCH);
export const fetchRegisterDataActionDone = createAction(ENTRANT_REGISTER + FETCH + DONE);
export const fetchRegisterDataActionFail = createAction(ENTRANT_REGISTER + FETCH + FAIL);
export const fetchRegisterDataActionReset = createAction(ENTRANT_REGISTER + RESET);
